import { render, staticRenderFns } from "./DatePickerV1Properties.vue?vue&type=template&id=37a19d7c&"
import script from "./DatePickerV1Properties.vue?vue&type=script&lang=js&"
export * from "./DatePickerV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports